module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/product-images/product-02-da0fada2183264d712d4f8c311a24e80.jpg";